class SizeHint {

	static _options = {
		selectors: {
			root: '.en_mdl_article_detail__sizehint',
			infoTrigger: '.en_mdl_article_detail__sizehint-info-trigger',
			info: '.en_mdl_article_detail__sizehint-info',
			section: '.en_mdl_article_detail__sizehint-section',
			indicator: '.en_mdl_article_detail__sizehint-indicator',
		},
	};

	constructor( elem ) {
		this.root = elem;
		this.infoTrigger = elem.querySelector( SizeHint._options.selectors.infoTrigger );
		this.info = elem.querySelector( SizeHint._options.selectors.info );
		this.sections = elem.querySelectorAll( SizeHint._options.selectors.section );
		this.indicator = elem.querySelector( SizeHint._options.selectors.indicator );
		this.infoOpen = false;

		this.infoTrigger.addEventListener( 'click', () => {
			if( this.infoOpen ) {
				this.root.classList.remove( 'is-info-visible' );
				setTimeout( () => {
					this.root.classList.remove( 'is-info-active' );
				}, 250 );
			} else {
				this.root.classList.add( 'is-info-active' );
				setTimeout( () => {
					this.root.classList.add( 'is-info-visible' );
				}, 1 );
			}
			this.infoOpen = !this.infoOpen;
		} );
	}
}

const initSizeHint = function( scopeEl = document ) {
	const sizeHintEls = Array.from( scopeEl.querySelectorAll( SizeHint._options.selectors.root ) );
	sizeHintEls.forEach( sizeHintEl => {
		sizeHintEl.SL_SizeHint ??= new SizeHint( sizeHintEl );
	} );
}

export {
	SizeHint as default,
	initSizeHint
}
